import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError, formatCDF } from "../../lib/api";
import AdminShell from "../../components/AdminShell";
import { Badge, Card } from "../../components/ui-kit";

export default function AdminPayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/payments")
      .then(({ data }) => setPayments(data))
      .catch((e) => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminShell title="Paiements">
      <h1 className="font-heading text-3xl font-black tracking-tighter sm:text-4xl">Paiements et transactions</h1>
      <div className="mt-5 grid grid-cols-1 gap-3 md:hidden">
        {payments.map((p) => (
          <Card key={p.id} className="p-4">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="font-mono text-lg font-black">{formatCDF(p.amount)}</div>
                <div className="text-xs text-muted-foreground">{p.method || p.provider || p.type || "paiement"}</div>
                <div className="mt-1 font-mono text-[10px] text-muted-foreground">#{String(p.ride_id || p.id).slice(0, 8)}</div>
              </div>
              <Badge tone={p.status === "COMPLETED" ? "success" : p.status === "FAILED" ? "danger" : "warning"}>
                {p.status || p.type}
              </Badge>
            </div>
          </Card>
        ))}
      </div>
      <Card className="mt-6 hidden overflow-x-auto md:block">
        <table className="w-full text-sm">
          <thead className="border-b-2 border-foreground bg-secondary text-secondary-foreground">
            <tr>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">ID</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Course</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Montant</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Methode</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Statut</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Date</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p.id} className="border-b border-border">
                <td className="p-3 font-mono text-xs">#{String(p.id).slice(0, 8)}</td>
                <td className="p-3 font-mono text-xs">{p.ride_id ? `#${String(p.ride_id).slice(0, 8)}` : "-"}</td>
                <td className="p-3 font-mono font-bold">{formatCDF(p.amount)}</td>
                <td className="p-3 text-xs">{p.method || p.provider || p.type || "-"}</td>
                <td className="p-3"><Badge tone={p.status === "COMPLETED" ? "success" : p.status === "FAILED" ? "danger" : "warning"}>{p.status || p.type}</Badge></td>
                <td className="p-3 text-xs">{p.created_at ? new Date(p.created_at).toLocaleString("fr-FR") : "-"}</td>
              </tr>
            ))}
            {!loading && payments.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-xs font-bold uppercase tracking-widest text-muted-foreground">Aucun paiement</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </AdminShell>
  );
}
